// extracted by mini-css-extract-plugin
export var modal = "_uv-0";
export var table = "_uv-1";